var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1050_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 31.1665C14.6666 29.2216 15.4392 27.3563 16.8145 25.9811C18.1898 24.6058 20.055 23.8332 22 23.8332C23.9449 23.8332 25.8101 24.6058 27.1854 25.9811C28.5607 27.3563 29.3333 29.2216 29.3333 31.1665H27.5C27.5 29.7078 26.9205 28.3089 25.889 27.2774C24.8576 26.246 23.4587 25.6665 22 25.6665C20.5413 25.6665 19.1423 26.246 18.1109 27.2774C17.0794 28.3089 16.5 29.7078 16.5 31.1665H14.6666ZM22 22.9165C18.9612 22.9165 16.5 20.4553 16.5 17.4165C16.5 14.3778 18.9612 11.9165 22 11.9165C25.0387 11.9165 27.5 14.3778 27.5 17.4165C27.5 20.4553 25.0387 22.9165 22 22.9165ZM22 21.0832C24.0258 21.0832 25.6666 19.4423 25.6666 17.4165C25.6666 15.3907 24.0258 13.7498 22 13.7498C19.9741 13.7498 18.3333 15.3907 18.3333 17.4165C18.3333 19.4423 19.9741 21.0832 22 21.0832Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_6374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default-user.2f274fcba72bca3d95586a94738d31ac.svg";
export { ForwardRef as ReactComponent };